import { cn } from "@/lib/utils";
import { MdError } from "react-icons/md";

type SearchResultErrorProps = {
  error: Error;
  design: "old" | "new";
  className?: string;
};

export default function SearchResultError({ error, className }: SearchResultErrorProps) {
  return (
    <div className={cn("flex flex-row p-4", className)}>
      <div className="icon-block">
        <MdError />
      </div>
      <div>
        <h4 className="mb-2 mt-0 text-action">{"Error: " + error.name}</h4>
        <div className="block text-center text-sm text-suppressed">
          {error.message}
        </div>
      </div>
    </div>
  );
}
